import { useRefinementList } from 'react-instantsearch'

export default function AlgoliaFilterList(props) {
  const { items, refine } = useRefinementList(props)
  const heading = props?.heading

  if (!items.length) {
    return null
  }

  return (
    <>
      {heading ? <h5 className="h5 mb-md font-semibold">{heading}</h5> : null}

      <ol className="grid sm:grid-cols-2 gap-y-2xs">
        {items.map((item) => (
          <li key={item.label} className="block">
            <label className="flex items-center gap-x-[8px]">
              <input
                type="checkbox"
                checked={item.isRefined}
                onChange={() => refine(item.value)}
                className="w-[16px] h-[16px] accent-gold"
              />
              <span className="text-[18px] text-black">{item.label}</span>
            </label>
          </li>
        ))}
      </ol>
    </>
  )
}
